import { Session } from '@supabase/supabase-js';

/**
 * Sets the current Supabase auth session
 */
export class SetSession {
    static readonly type = '[Auth] Set session';

    constructor(public readonly session: Session | null) {
    }
}
